


































































































































































import { format } from 'date-fns'
import fromUnixTime from 'date-fns/fromUnixTime'
import { Icon } from '@alpha/ink'
import {
  workspaceForTest,
  experimentsForTest,
  ViewOption
} from '@/utilities/priority-helpers'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { setTimeout } from 'timers'
import { uniqBy } from 'lodash-es'
import { OrganizationUsers, ActiveTest } from '../../views/TestQueue.vue'

@Component({
  components: {
    Icon
  }
})
export default class Table extends Vue {
  @Prop({ required: true }) tests!: ActiveTest[]
  @Prop({ required: true }) workspaces!: ViewOption[]
  @Prop({ required: true }) users!: OrganizationUsers
  @Prop({ default: false }) editable!: boolean
  @Prop({ required: true }) showOrgPosition!: boolean
  @Prop({ default: true }) showPositions!: boolean
  @Prop({ default: false }) showToTopFirstIndex!: boolean
  @Prop({ default: 1 }) initialIndex!: number
  @Prop({ default: false }) showWorkspaces!: boolean
  @Prop({ default: false }) showExperiments!: boolean
  @Prop({ type: [Object, Boolean], default: false }) draggedTest!: ActiveTest | boolean
  @Prop({ default: () => [] }) priorityTests!: ActiveTest[]
  @Prop({ type: [Array, Boolean], default: false }) orgPositions!: number[] | boolean
  @Prop({ default: false }) showLocks!: boolean
  @Prop({ default: () => null }) markTest!: number | null

  @Ref('allTestItems') readonly allTestItems!: HTMLElement[] | null

  highLightedTestId: number | null = this.markTest

  mounted () {
    if (this.highLightedTestId) {
      this.emitItemOffset(this.highLightedTestId)
      setTimeout(() => {
        this.highLightedTestId = null
      }, 2000)
    }
  }

  emitItemOffset (id: any) {
    if (!this.allTestItems) return
    const selectedListItem = this.allTestItems.find(item => {
      return parseInt(item.id) === this.highLightedTestId
    })
    if (selectedListItem) {
      const selectedEl = selectedListItem as HTMLElement
      const offsetTop = selectedEl.offsetTop - 50
      this.$emit('markedTest', { offsetTop })
    }
  }

  get allTests (): ActiveTest[] {
    return uniqBy(this.priorityTests.concat(this.tests), (test) => `${test.workspaceId}--${test.id}`)
  }

  get workspaceForTest () {
    return workspaceForTest
  }

  get experimentsForTest () {
    return experimentsForTest
  }

  toTop (test: ActiveTest, index: number) {
    this.$emit('toTop', test, index)
  }

  testCreator (test: ActiveTest): string {
    const userId = test.createdBy.id
    const user = this.users.find(user => user.id === userId)
    if (!user) return `${userId}`

    let fullname = user.payload.firstname
    if (user.payload.lastname) {
      fullname += ' ' + user.payload.lastname
    }
    return fullname
  }

  formatUnixTime (time: number): string {
    const timestamp:Date = fromUnixTime(time)
    return format(timestamp, 'MM/dd/yy')
  }

  isDragging (test: ActiveTest, index: number): boolean {
    if (!this.draggedTest) return false
    return (this.draggedTest as ActiveTest).workspaceId === test.workspaceId &&
      (this.draggedTest as ActiveTest).id === test.id
  }

  dragstart (event: DragEvent, test: ActiveTest, index: number) {
    // Lol firefox requires this???
    if (event && event.dataTransfer) {
      event.dataTransfer.setData('text', 'anything')
    }

    // The dom takes a snapshot of the dragged element the instant
    // of @dragstart. By using set timeout, we can apply classes
    // to the in-flow element without affecting the dragged elements
    // appearance
    setTimeout(() => {
      this.$emit('dragstart', test, index)
    }, 1)
  }

  dragend (event: DragEvent, test: ActiveTest, index: number) {
    this.$emit('dragend', test, index)
  }

  dragover (event: DragEvent, test: ActiveTest, index: number) {
    event.preventDefault()
  }

  dragenter (event: DragEvent, test: ActiveTest, index: number) {
    this.$emit('dragenter', test, index)
  }

  dragleave (event: DragEvent, test: ActiveTest, index: number) {
  }

  drop (event: DragEvent, test: ActiveTest, index: number) {
    // Firefox will try to redirect you on drop w/o this
    event.preventDefault()
  }

  lockTest (event: Event, test: ActiveTest, index: number) {
    if (!this.editable) return
    this.$emit('lockTest', test, index)
  }

  unlockTest (event: Event, test: ActiveTest, index: number) {
    if (!this.editable) return
    this.$emit('unlockTest', test, index)
  }

  isPriority (test: ActiveTest): boolean {
    return this.priorityTests.indexOf(test) !== -1
  }
}
